// Trạng thái "Phòng máy" (QĐ 0541) cho cổng menu.
//
// Cổng menu là hàm thường (không gọi hook được) nên đọc kho này đồng bộ; kho
// được nạp bởi useHunchRoomMeSync (api.ts) ở useSidebarData — cùng khuôn với
// features/sealed-inbox/flag.ts. Tệp này KHÔNG được nhập máy khách API: cổng
// menu còn chạy trong kịch bản dựng bộ hướng dẫn (node).
import { create } from "zustand";

export interface HunchRoomFlag {
  /** Máy chủ đã đặt HUNCH_ROOM_KEY — tắt thì mục menu ẩn. */
  enabled: boolean;
  /** Có tên trong phòng (người giữ phòng hoặc người thứ hai). */
  isMember: boolean;
  /** Người giữ phòng: thêm / gỡ được người thứ hai. */
  isChief: boolean;
}

export const HUNCH_ROOM_OFF: HunchRoomFlag = { enabled: false, isMember: false, isChief: false };

interface State extends HunchRoomFlag {
  set: (v: HunchRoomFlag) => void;
}

export const useHunchRoomFlag = create<State>((set) => ({
  ...HUNCH_ROOM_OFF,
  set: (v) => set(v),
}));
